import type ShareToSlackIntegrationsType from '@atlassian/integrations';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyShareToSlack = lazyAfterPaint<typeof ShareToSlackIntegrationsType>(
	() =>
		import(/* webpackChunkName: "async-share-to-slack" */ '@atlassian/integrations/share-to-slack'),
	{ ssr: false },
);
